import { attr } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

/**
 * Is created when the Profiler has been retrieved. Meaning we've called the Profiler service
 * and it has returned the PPS for the patient
 */
export default class ProfilerRetrievedJournalEvent extends JournalEvent {
  static override type = "profiler-retrieved-journal-event";

  /**
   * The PPS of the patient
   */
  @attr() declare pps: any[];

  /**
   * The profiles and their relation that led to the PPS of the patient
   */
  @attr() declare profiles: any[];

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.profiler-retrieved-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "profiler-retrieved-journal-event": ProfilerRetrievedJournalEvent;
  }
}
